export const CHANGE_ADMIN_ROLE = 'CHANGE_ADMIN_ROLE';
export const CHANGE_ADMIN_ROLE_SUCCESS = 'CHANGE_ADMIN_ROLE_SUCCESS';
export const CHANGE_ADMIN_ROLE_FAILS = 'CHANGE_ADMIN_ROLE_FAILS';
export const FETCH_ALL_USERS = 'FETCH_ALL_USERS ';
export const FETCH_ALL_USERS_SUCCESS = 'FETCH_ALL_USERS_SUCCESS';
export const FETCH_ALL_USERS_FAIL = 'FETCH_ALL_USERS_FAIL';
export const FETCH_USERS_BY_USERNAME = 'FETCH_USERS_BY_USERNAME';
export const FETCH_USERS_BY_USERNAME_SUCCESS = 'FETCH_USERS_BY_USERNAME_SUCCESS';
export const FETCH_USERS_BY_USERNAME_FAIL = 'FETCH_USERS_BY_USERNAME_FAIL';
export const RESET_USER_DATA = 'RESET_USER_DATA';
